import { getAdvancedMatchingParams } from './userData';

const PINTEREST_TAG_ID = '2613050452922';

let initialised = false;

function getPintrk(): ((...args: unknown[]) => void) | null {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return typeof window !== 'undefined' ? (window as any).pintrk ?? null : null;
}

/**
 * Inject the Pinterest tag and fire the initial `load` + `page` events.
 * Passes user email for enhanced matching when available (Pinterest hashes it client-side).
 * Safe to call multiple times – subsequent calls are no-ops.
 */
export function initPinterestTag(): void {
  if (initialised) return;
  if (typeof window === 'undefined') return;

  try {
    // eslint-disable-next-line
    (function (e: any) {
      if (!(window as any).pintrk) {
        (window as any).pintrk = function () {
          (window as any).pintrk.queue.push(Array.prototype.slice.call(arguments));
        };
        const n = (window as any).pintrk;
        n.queue = [];
        n.version = '3.0';
        const t = document.createElement('script');
        t.async = true;
        t.src = e;
        const r = document.getElementsByTagName('script')[0];
        r.parentNode!.insertBefore(t, r);
      }
    })('https://s.pinimg.com/ct/core.js');

    const pintrk = getPintrk();
    if (pintrk) {
      const matchParams = getAdvancedMatchingParams();
      const loadOptions = matchParams?.em ? { em: matchParams.em } : {};
      pintrk('load', PINTEREST_TAG_ID, loadOptions);
      pintrk('page');
    }

    initialised = true;
  } catch (err) {
    console.error('[Pinterest] Failed to initialise:', err);
  }
}

/** Fire a Pinterest page view (SPA route changes). */
export function trackPinterestPageView(): void {
  const pintrk = getPintrk();
  if (!pintrk || !initialised) return;
  try {
    pintrk('page');
  } catch { /* swallow */ }
}

/** Fire a Pinterest standard event (e.g. 'checkout', 'signup', 'lead'). */
export function trackPinterestEvent(
  eventName: string,
  params?: Record<string, unknown>,
  eventId?: string,
): void {
  const pintrk = getPintrk();
  if (!pintrk || !initialised) return;
  try {
    pintrk('track', eventName, { ...(params ?? {}), ...(eventId ? { event_id: eventId } : {}) });
  } catch { /* swallow */ }
}

export function isPinterestInitialised(): boolean {
  return initialised;
}
